module.exports = __webpack_public_path__ + "fonts/95271da8-8990-4306-bc7f-0e2d1a92f72e.e8df001.eot";